import React, { useState } from "react";
import axios from "axios";
import Header from "./Layout/Header";
import SideBar from "./Layout/SideBar";
import { baseURL } from "../axios/common";

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
    confirm_password: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.new_password !== formData.confirm_password) {
      alert("New password and confirm password do not match");
      return;
    }
    try {
      const response = await axios.post(baseURL + "admin/changePassword", {
        old_password: formData.old_password,
        new_password: formData.new_password,
        language: "en"
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });
      alert(response.data.message);
    } catch (error) {
      alert(error.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <>
      <Header />
      <SideBar />
      <main>
        <div className="content-wrapper pt-5 changePassword">
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header">
                      <h2>Change Password</h2>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-md-7 mb-3">
                            <label htmlFor="old_password" className="form-label">
                              Old Password:
                            </label>
                            <input
                              type="password"
                              className="form-control"
                              id="old_password"
                              name="old_password"
                              value={formData.old_password}
                              onChange={handleChange}
                              required
                            />
                          </div>

                          <div className="col-md-7 mb-3">
                            <label htmlFor="new_password" className="form-label">
                              New Password:
                            </label>
                            <input
                              type="password"
                              className="form-control"
                              id="new_password"
                              name="new_password"
                              value={formData.new_password}
                              onChange={handleChange}
                              required
                            />
                          </div>

                          <div className="col-md-7 mb-3">
                            <label htmlFor="confirm_password" className="form-label">
                              Confirm Password:
                            </label>
                            <input
                              type="password"
                              className="form-control"
                              id="confirm_password"
                              name="confirm_password"
                              value={formData.confirm_password}
                              onChange={handleChange}
                              required
                            />
                          </div>

                          <div className="col-md-6">
                            <button type="submit" className="btn btn-primary w-30">
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default ChangePassword;
